// Shared snake_case rule for every identifier the backend cross-references
// by exact string match: document-type field IDs, output_resolution keys,
// product type IDs, document type IDs, extractor IDs. Real incident
// (STATUS.md, legalflow-idp): a field named "Account Number" and its
// output_resolution key account_number didn't match in casing - this is
// the client-side half of closing that at the source (hard-reject, not
// auto-convert - confirmed with Safdar), matching the exact backend rule
// (configs/schemas/*.json's new propertyNames, PRD 34) so a value this
// accepts is guaranteed schema-valid, never a false negative here that
// still fails server-side.
//
// firm_id is deliberately NOT covered by this rule - a different,
// established UPPER_SNAKE_CASE convention (see deriveFirmId in
// client-overrides/overrideUtils.ts), and not free text to begin with.
export const IDENTIFIER_PATTERN = /^[a-z][a-z0-9]*(_[a-z0-9]+)*$/

export const IDENTIFIER_RULE_MESSAGE =
  'Use lowercase letters, numbers, and underscores only, starting with a letter (no spaces).'

export function isValidIdentifier(value: string): boolean {
  return IDENTIFIER_PATTERN.test(value)
}

export interface IdentifierFieldStatus {
  trimmedId: string
  isDuplicateId: boolean
  isInvalidShape: boolean
  isValid: boolean
}

// Validation for a typed identifier in a "New or Duplicate" modal: blank is
// simply not yet valid (no message), a collision with an existing id is
// reported before a shape error, and the id used is always the trimmed one.
// The firm modal does not use this - its id is derived from the typed name
// (deriveFirmId), never typed directly. PRD 14.
export function evaluateIdentifierField(id: string, existingIds: string[]): IdentifierFieldStatus {
  const trimmedId = id.trim()
  const isDuplicateId = trimmedId.length > 0 && existingIds.includes(trimmedId)
  const isInvalidShape = trimmedId.length > 0 && !isDuplicateId && !isValidIdentifier(trimmedId)
  const isValid = trimmedId.length > 0 && !isDuplicateId && !isInvalidShape
  return { trimmedId, isDuplicateId, isInvalidShape, isValid }
}
